// Cosas de vite
import 'vite/modulepreload-polyfill'

// Import css files
import "../Styles/App.scss";
import "bootstrap-icons/font/bootstrap-icons.scss";

// Import libraries
import "bootstrap";

// Resto de imports
import { BaseClass, GetTipoRespuestaByString } from "./Shared/Utils";
import { TipoRespuesta } from './Shared/ApiRespuesta';
import { ShowKendoNotification } from './Shared/KendoHelpers';

window.i3 = {};

/**
 * Clase con los métodos usados por el layout principal.
 */
export class LayoutPrincipal implements BaseClass {
    constructor() {
        this.AddEventos();
        this.IniciarPagina();
    }

    AddEventos() {
        document.getElementById('ToggleMenuBtn')?.addEventListener('click', (e: Event) => this.ToggleMenu());
        const botoneraToggler = document.getElementById('botoneraToggler');
        botoneraToggler?.addEventListener('click', () => {
            botoneraToggler?.classList.toggle('active');
            const botonera = document.querySelector('.botonera-general');
            botonera?.classList.toggle('active');
        });
    }

    IniciarPagina() {

        if (document.querySelector('.botonera-general') == null) {
            const botonera = document.getElementById('botoneraToggler');
            if (botonera != null) {
                (botonera as HTMLDivElement).style.display = 'none';
            }
        }

        document.addEventListener("readystatechange", (event) => {
            let tipo = document.getElementById("TipoMensaje") as (HTMLInputElement | undefined);
            let mensaje = document.getElementById("Mensaje") as (HTMLInputElement | undefined);

            if (mensaje && tipo) {
                ShowKendoNotification("comentarioKendo", mensaje.value, GetTipoRespuestaByString(tipo.value));
            }
        });
    }

    private ToggleMenu() {
        document.getElementById('AppMenu')?.classList.toggle("app-menu-toggled");
        const kendoNotificacion = $("#comentarioKendo")?.data("kendoNotification");
    }
}

window.i3.OnShowNotification = function (e: any) {
    if (e.sender.getNotifications().length == 1) {
        var element = e.element.parent().parent(),
            eWidth = element.width(),
            wWidth = $(window).width() ?? 0,
            newLeft;

        newLeft = Math.floor(wWidth / 2 - eWidth / 2);

        e.element.parent().parent().css({ bottom: 20, left: newLeft });
    }
}

window.i3.KendoErrorHandler = function KendoErrorHandler(e: any) {
    if (e.errors) {
        $.each(e.errors, function (key, value) {
            if (key == 'KendoGridGetAllError') {
                ShowKendoNotification("comentarioKendo", value.errors.toString(), TipoRespuesta.Error);
            }
            else if (key == 'KendoGridEditError') {
                ShowKendoNotification("comentarioKendo", value.errors.toString(), TipoRespuesta.Error);

                // Recargar Grid
                const grid = e.sender;
                if (!grid.page() || grid.page() === 1) {
                    grid.read();
                } else {
                    grid.page(1);
                }
            }
            else if (key == 'KendoGridEditWarning') {
                ShowKendoNotification("comentarioKendo", value.errors.toString(), TipoRespuesta.Warning);

                // Recargar Grid
                const grid = e.sender;
                if (!grid.page() || grid.page() === 1) {
                    grid.read();
                } else {
                    grid.page(1);
                }
            }
        });
    }
}

window.i3.KendoEndHandler = function KendoEndHandler(e: any) {
    if (e.type == "create") {
        // Recargar Grid
        const grid = e.sender;
        if (!grid.page() || grid.page() === 1) {
            grid.read();
        } else {
            grid.page(1);
        }
    }
    else if (e.type == "update") {
        // Recargar Grid
        const grid = e.sender;
        if (!grid.page() || grid.page() === 1) {
            grid.read();
        } else {
            grid.page(1);
        }
    }
}

window.i3.UpdateStickyTopDistance = function UpdateStickyTopDistance(e: any) {
    const a = document.querySelector(".k-grid-header") as HTMLElement;
    const b = document.querySelector(".navigation-header") as HTMLElement;
    if (a != null) {
        a.style.top = `${b.scrollHeight}px`;
    }
}

window.i3.animalesMovidosADestino = [] as Array<any>;
window.i3.animalesMovidosAOrigen = [] as Array<any>;

if ('serviceWorker' in navigator) {
    // Wait for the 'load' event to not block other work
    window.addEventListener('load', async () => {
        // Try to register the service worker.
        try {
            const reg = await navigator.serviceWorker.register('/InformeGanadero/ServiceWorker.js');
        } catch (err) {
        }
    });
}

new LayoutPrincipal();